import React from "react";
import PropTypes from "prop-types";
import { WalletContainer, WalletHeader } from "../../../auth/wallet/walletStyles";
import { Button, Typography, Box } from "@mui/material";
import PinComponent from "../../../auth/wallet/PinComponent";

export const RegisterAssetModal = ({
	onCloseModal,
	amountPayable,
	loading,
	handleRegisterAsset,
	activeTab,
	setActiveTab,
}) => {
	// console.log(activeTab);
	return (
		<>
			{activeTab === 1 && (
				<WalletContainer>
					<>
						<WalletHeader
							headerText='Asset Registration Payment'
							context='You need to make payment for vehicle registration.'
							onCloseModal={onCloseModal}
						/>
						<Typography
							marginY={2}
							color='black'>{`NGN ${amountPayable?.toLocaleString()} will be deducted from the wallet for your vehicle registration.`}</Typography>
						<Box display='grid' gridTemplateColumns='1fr 1fr' gap={2}>
							<Button variant='outlined' color='error' onClick={onCloseModal}>
								cancel
							</Button>
							<Button variant='contained' color='primary' onClick={() => setActiveTab(2)}>
								proceed
							</Button>
						</Box>
					</>
				</WalletContainer>
			)}
			{activeTab === 2 && (
				<PinComponent onClose={onCloseModal} onDeductFunds={handleRegisterAsset} isLoading={loading} />
			)}
		</>
	);
};

export const InsureAssetModal = ({
	onCloseModal,
	amountPayable,
	loading,
	handleInsurancePayment,
	activeTab,
	setActiveTab,
}) => {
	// console.log(activeTab);
	return (
		<>
			{activeTab === 1 && (
				<WalletContainer>
					<>
						<WalletHeader
							headerText='Asset Insurace Payment'
							context='You need to make payment asset insurance.'
							onCloseModal={onCloseModal}
						/>
						<Typography
							marginY={2}
							color='black'>{`NGN ${amountPayable?.toLocaleString()} will be deducted from the wallet for your asset insurance.`}</Typography>
						<Box display='grid' gridTemplateColumns='1fr 1fr' gap={2}>
							<Button variant='outlined' color='error' onClick={onCloseModal}>
								cancel
							</Button>
							<Button variant='contained' color='primary' onClick={() => setActiveTab(2)}>
								proceed
							</Button>
						</Box>
					</>
				</WalletContainer>
			)}
			{activeTab === 2 && (
				<PinComponent onClose={onCloseModal} onDeductFunds={handleInsurancePayment} isLoading={loading} />
			)}
		</>
	);
};

RegisterAssetModal.propTypes = {
	loading: PropTypes.bool,
	onCloseModal: PropTypes.func,
	amountPayable: PropTypes.number,
	activeTab: PropTypes.number,
	setActiveTab: PropTypes.func,
	handleRegisterAsset: PropTypes.func,
};

InsureAssetModal.propTypes = {
	loading: PropTypes.bool,
	onCloseModal: PropTypes.func,
	amountPayable: PropTypes.number,
	activeTab: PropTypes.number,
	handleInsurancePayment: PropTypes.func,
	setActiveTab: PropTypes.func,
};
